import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logo from 'images/insurgate_dark.svg';
import { useCurrentBrand } from 'contexts/current_brand/use_current_brand';
import { useI18n } from 'hooks/use_i18n';

const LogoContainerTag = ({ as, className, ...rest }) => {
  switch (as) {
    case 'link':
      return <Link to="/" className={`${className && className} text-decoration-none`} {...rest} />;
    case 'a':
      return <a href={rest.href} className={`${className && className} text-decoration-none`} {...rest} />;
    default:
      return <Link to="/" className={`${className && className} text-decoration-none`} {...rest} />;
  }
};

const Logo = ({ width, className, as, ...rest }) => {
  const { currentBrand } = useCurrentBrand();
  const { getCurrentLocale } = useI18n();
  const locale = getCurrentLocale();

  const currentLocaleLogo = currentBrand?.[`logo_${locale}_url`];
  const fallbackLogo = currentBrand?.logo_fr_url;

  return (
    <React.Fragment>
      <LogoContainerTag as={as} className={`${className} `} {...rest}>
        <img src={currentBrand ? currentLocaleLogo || fallbackLogo : logo} alt="Logo" width={currentBrand ? width : '150px'} />
      </LogoContainerTag>
    </React.Fragment>
  );
};

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  as: PropTypes.oneOf(['link', 'a']),
};

Logo.defaultProps = {
  as: 'link',
  className: '',
  width: '',
};

export default Logo;
